import React, { useEffect, useState } from "react";
import delete_Vector from "../utils/delete_Vector.jpg";
import { AiFillDelete } from "react-icons/ai";
import filter from "../utils/filter.png";
import { AiOutlineSearch } from "react-icons/ai";
import { Link as RouterLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Outlet, useLocation } from "react-router-dom";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import { Button, ButtonGroup } from "@mui/material";
import KanbanViewQualified from "./KanbanQualified";
import { AiOutlineClose } from "react-icons/ai";
import kanban from "../utils/kanban.png";
import table from "../utils/mainTable.svg";
import grouped from "../utils/group.svg";
import Drawer from "./Drawer";
import products from "../utils/products.png";
import LeadStageModal from "../modals/LeadStageModal";
import LeadFilterModal from "../modals/LeadFilterModal";
import QualifiedGrouped from "./QualifiedGrouped";
import { useBreadcrumbs } from "../modals/BreadcrumbsContext";
import expand from "../utils/expand.png";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import axios from "axios";
import { format } from "date-fns";

const QualifiedLeads = () => {

  let company_code_from_local_storage = localStorage.getItem("companyCode") ? localStorage.getItem("companyCode") : "-"
  let apiPaths_from_local_storage = localStorage.getItem("apiPaths") ? JSON.parse( localStorage.getItem("apiPaths") ) : "-"

  const [freetext, setFreetext] = useState("-")

  const [leadsWithProducts, setLeadsWithProducts] = useState(new Set());
  // const [userDepartment, setUserDepartment] = useState(null);

  useEffect(() => {
    // setUserDepartment(localStorage.getItem("currentSelectedDepartment"))
    const userDepartment = localStorage.getItem("currentSelectedDepartment");
    console.log("userDepartment", userDepartment);
    callQualifiedLeadList(userDepartment);
  }, []);

  useEffect(() => {

      const userDepartment = localStorage.getItem("currentSelectedDepartment");
      console.log("userDepartment", userDepartment);

      callQualifiedLeadList(userDepartment)
    

  }, [freetext])

  const todayDate = format(new Date(), "yyyy-MM-dd");

  const callQualifiedLeadList = (userDepartment) => {

    let textToSearch = "-"

    if(freetext != ""){
      textToSearch = freetext
    }
    
    console.log("userDepartment", userDepartment);

    const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
    const empIDFromUserObjectInLocalStorage = currentUserObject[0].EMPID;

    const userAccessGroup = currentUserObject[0].accessgrp;

    let taskCordinatorValue = userAccessGroup?.trim().toUpperCase() == "COORDINATOR" ? empIDFromUserObjectInLocalStorage : "-"
    let taskSalesValue = (userAccessGroup?.trim().toUpperCase() != "COORDINATOR" && userAccessGroup?.trim().toUpperCase() != "ADMIN" && userAccessGroup?.trim().toUpperCase() != "CADMIN") ? empIDFromUserObjectInLocalStorage : "-"

    const apiurl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMLeadMainList/${company_code_from_local_storage}/ALL/-/-/-/-/${userDepartment}/1900-01-01/${todayDate}/${textToSearch}/qualified/-?task_coordinator=${taskCordinatorValue}&task_salesperson=${taskSalesValue}&task_creator_id=-`;

    // console.log("Fetching data from:", apiurl);
    // console.log("taskCordinatorValue:", taskCordinatorValue);
    console.log("taskSalesValue:", taskSalesValue);
    console.log("empIDFromUserObjectInLocalStorage:", empIDFromUserObjectInLocalStorage);

    axios
      .get(apiurl)
      .then((res) => {
        const updatedData = res.data.map((lead) => ({
          ...lead,
          lead_stage: lead.lead_stage ? lead.lead_stage : "new", // Set "new" if empty
        }));

        setFilteredQualifiedLeadRows(updatedData);
        // console.log("res.data:", res.data);

        // Extract lead IDs with Cnt > 0
        const leadsWithCount = new Set(
          res.data.filter((lead) => lead.Cnt > 0).map((lead) => lead.lead_id)
        );

        // console.log("Leads with products:", leadsWithCount);
        setLeadsWithProducts(leadsWithCount);
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
      });
  };


  const { showBreadcrumbs, setShowBreadcrumbs } = useBreadcrumbs();

  const handleBreadCrumbsClick = (event) => {
    event.preventDefault();
    console.info("You clicked a breadcrumb.");
  };

  const [discoveryLeads, setDiscoveryLeads] = useState(
    JSON.parse(localStorage.getItem("discoveryLeads")) || [] // Initialize from localStorage if available
  );

  const [wonLeads, setWonLeads] = useState(
    JSON.parse(localStorage.getItem("wonLeads")) || [] // Initialize from localStorage if available
  );

  const [lostLeads, setLostLeads] = useState(
    JSON.parse(localStorage.getItem("lostLeads")) || [] // Initialize from localStorage if available
  );

  const [showStageModal, setShowStageModal] = useState(false); // To control the visibility of the modal

  const [qualifiedLeads, setQualifiedLeads] = useState(
    JSON.parse(localStorage.getItem("leadTableData"))?.map((lead) => ({
      ...lead,
      stage: lead.stage ?? "new",
    })) || []
  );

  // const [leads, setLeads] = useState([]); // Array of leads
  // const [quoteModal, setQuoteModal] = useState(false); // Manage the quote modal state
  const [productDetails, setProductDetails] = useState(null); // Manage product details state
  const [selectedLeads, setSelectedLeads] = useState([]); // State to track selected leads
  const [checkedLead, setCheckedLead] = useState(""); // State to track selected leads
  const [showDeleteModal, setShowDeleteModal] = useState(false); // Modal state
  const [showDrawer, setShowDrawer] = useState(false); // Drawer visibility state
  const [selectedLead, setSelectedLead] = useState(null); // Store selected lead for
  const [viewMode, setViewMode] = useState("Grouped"); // View mode state
  const [history, setHistory] = useState([]); // State to track history of selected lead
  // const [timeline, setTimeline] = useState([]); // State to track history of selected lead
  const [showLeadFilter, setShowLeadFilter] = useState(false);
  const [searchTerm, setSearchTerm] = useState(""); // Search term state
  const [rows, setRows] = useState([]);
  // const [rows, setRows] = useState(() => {
  //   const savedData = localStorage.getItem("qualifiedLeads");
  //   return savedData ? JSON.parse(savedData) : [];
  // });
  const [filteredQualifiedLeadRows, setFilteredQualifiedLeadRows] =
    useState(qualifiedLeads);

  // useEffect(() => {
  //   localStorage.setItem("qualifiedLeads", JSON.stringify(qualifiedLeads)); // Save qualified leads to localStorage
  // }, [qualifiedLeads]);

  const stageMapping = {
    new: "New",
    discovery: "Discovery",
    proposal: "Proposal",
    negotiation: "Negotiation",
    won: "Won",
    lost: "Lost",
  };

  const handleCheckboxChange = (id, row) => {

    console.log("id and row checkbox", row)

    setCheckedLead(row.lead);
    setSelectedLeads((prev) =>
      prev.includes(id) ? prev.filter((leadId) => leadId !== id) : [...prev, id]
    );
  };

  const deleteSelectedLeads = () => {
    const updatedLeads = qualifiedLeads.filter(
      (lead) => !selectedLeads.includes(lead.id)
    );
    setQualifiedLeads(updatedLeads);
    setSelectedLeads([]); // Clear selected leads after deletion
    setShowDeleteModal(false); // Close modal after deletion
  };

  const closeModal = () => {
    setShowDeleteModal(false); // Close modal
  };
  const closeDeleteModal = () => {
    setShowDeleteModal(false); // Close modal
  };

  const viewLead = (id) => {
    // console.log('id in viewLead',id)
    const lead = filteredQualifiedLeadRows.find((lead) => lead.lead_id == id);
    console.log("lead", lead);
    setSelectedLead(lead);
    setShowDrawer(true); // Show Drawer
  };

  const handleStageChange = (field, newStage) => {
    // console.log("field:", field);
    // console.log("newStage:", newStage);
    setSelectedLead((prevLead) => ({
      ...prevLead,
      [field]: newStage,
    }));

    // console.log("selectedLead in stage change", selectedLead);
  };

  const handleInputChange = (e, field) => {
    console.log("clicked from grouped qualified!!");
    setSelectedLead((prevLead) => ({
      ...prevLead,
      [field]: e.target.value,
    }));
  };

  const handleSave = (e) => {
    e.preventDefault();

    const updatedLead = { ...selectedLead };
    const originalLead = qualifiedLeads.find(
      (lead) => lead.id === selectedLead.id
    );

    let isChanged = false; // Track if any field has changed
    const updatedHistory = [...(updatedLead.history || [])]; // Ensure history exists

    Object.keys(updatedLead).forEach((field) => {
      const oldValue = originalLead[field];
      const newValue = updatedLead[field];
      if (oldValue !== newValue) {
        // Log the change in history
        updatedHistory.push({
          date: new Date().toISOString(),
          activity: `Field "${field}" updated`,
          note: `Changed from "${oldValue}" to "${newValue}"`,
        });
        isChanged = true;
      }
    });

    if (isChanged) {
      updatedLead.history = updatedHistory;
    }

    // Update state and localStorage
    const updatedLeads = qualifiedLeads.map((lead) =>
      lead.id === selectedLead.id ? updatedLead : lead
    );
    setQualifiedLeads(updatedLeads); // Update state
    console.log("Updated leads:", updatedLeads);
    //localStorage.setItem("qualifiedLeads", JSON.stringify(updatedLeads));

    setShowDrawer(false); // Close the drawer
  };

  const openStatusModal = (lead) => {
    setSelectedLead(lead);
    setShowStageModal(true);
  };

  const closeStatusModal = () => {
    setShowStageModal(false);
  };

  const handleEdit = (lead) => {
    setSelectedLead(lead);
    setHistory(lead.history || []); // Initialize history for the selected lead
    setShowDrawer(true);
  };

  const updateStageToWon = (leadId) => {
    // Find the lead to update
    const leadToMoveWon = rows.find((row) => row.lead_id === leadId);
    if (!leadToMoveWon) return; // Guard against invalid ID

    // Create a new timeline entry for the status change to "Won"
    const currentTimestamp = new Date().toISOString(); // Get the current timestamp
    const statusChangeTimeline = {
      date: currentTimestamp,
      activity: "Stage changed to Won",
    };

    // Ensure timeline exists and is an array, then add the new activity
    const updatedQualifiedLeadWon = {
      ...leadToMoveWon,
      stage: "won", // Update stage to won
      timeline: Array.isArray(leadToMoveWon.timeline)
        ? [...leadToMoveWon.timeline, statusChangeTimeline] // Add the new timeline entry
        : [statusChangeTimeline], // If no timeline, create a new array with the status change
    };

    // Update the rows state and remove the updated lead from rows
    setRows((prevRows) => {
      const updatedRows = prevRows.filter((row) => row.lead_id !== leadId);
      // console.log("updatedRows", updatedRows);

      // Save updated rows to localStorage
     // localStorage.setItem("qualifiedLeads", JSON.stringify(updatedRows));

      return updatedRows; // Update state with the filtered rows
    });

    // Add the updated lead to the wonLeads list
    const updatedWonLeads = [...wonLeads, updatedQualifiedLeadWon];
    setWonLeads(updatedWonLeads);
    // console.log("updatedWonLeads", updatedWonLeads);

    // Save updated wonLeads to localStorage
    localStorage.setItem("wonLeads", JSON.stringify(updatedWonLeads));

    // Close the modal
    setShowStageModal(false);
  };

  const updateStageToLost = (leadId) => {
    console.log("lead To move to lost:", leadId);
    // Find the lead to update
    const leadToMoveLost = rows.find((row) => row.lead_id === leadId);
    if (!leadToMoveLost) return; // Guard against invalid ID

    // Update the lead's stage to "lost"
    const updatedQualifiedLeadLost = { ...leadToMoveLost, stage: "lost" };

    // Update the rows state and remove the updated lead
    setRows((prevRows) => {
      const updatedRows = prevRows.filter((row) => row.lead_id !== leadId);
      // console.log("updatedRows", updatedRows);

      // Save updated rows to localStorage
     // localStorage.setItem("qualifiedLeads", JSON.stringify(updatedRows));
      // localStorage.setItem("lostLeads", JSON.stringify(updatedRows));

      return updatedRows; // Update state with the filtered rows
    });

    // Add the updated lead to the wonLeads list
    const updatedLostLeads = [...lostLeads, updatedQualifiedLeadLost];
    setLostLeads(updatedLostLeads);
    // console.log("updatedLostLeads", updatedLostLeads);

    // Save updated discoveryLeads to localStorage
    localStorage.setItem("lostLeads", JSON.stringify(updatedLostLeads));

    // Close the modal
    setShowStageModal(false);
  };

  const calculateAgedDays = (leadEntryTime) => {
    const entryTime = new Date(leadEntryTime);
    const currentTime = new Date();
    const diffInMilliseconds = currentTime - entryTime;

    const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));
    const diffInHours = Math.floor(
      (diffInMilliseconds % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );

    return `Aged Days: ${diffInDays} d, ${diffInHours} h`;
  };

  const onLeadFilter = () => {
    setShowLeadFilter(true);
  };

  const resetFilters = () => {
    setFilteredQualifiedLeadRows(qualifiedLeads);
  };

  const applyFilters = (filteredQualifiedLeads) => {
    console.log("filteredQualifiedLeads:", filteredQualifiedLeads);
    setFilteredQualifiedLeadRows(filteredQualifiedLeads);
  };

  const [filteredRows, setFilteredRows] = useState(qualifiedLeads);

  const handleSearch = (term) => {
    setSearchTerm(term);
    setFreetext(term)
    // if (term.trim() === "") {
    //   // setFilteredRows(rows);
    //   setFilteredQualifiedLeadRows(rows);
    // } else {
    //   // setFilteredRows(
    //   setFilteredQualifiedLeadRows(
    //     rows.filter((row) =>
    //       Object.values(row)
    //         .join(" ")
    //         .toLowerCase()
    //         .includes(term.toLowerCase())
    //     )
    //   );
    // }
  };

  const updateLeadStage = (leadId, newStage) => {
    console.log("updateLeadStage leadId", leadId);
    console.log("updateLeadStage newStage", newStage);
    setFilteredQualifiedLeadRows((prevLeads) =>
      prevLeads.map((lead) =>
        lead.id === leadId ? { ...lead, stage: newStage } : lead
      )
    );
    closeStatusModal(); // Close the modal after updating the stage
  };

  useEffect(() => {
    // localStorage.setItem(
    //   "qualifiedLeads",
    //   JSON.stringify(filteredQualifiedLeadRows)
    // );
  }, [filteredQualifiedLeadRows]);

  const handleQuoteModalChange = (newState) => {
    // setQuoteModal(newState);
  };

  const navigate = useNavigate();

  const [quoteLeadId, setQuoteLeadId] = useState("");

  const [selectedDate, setSelectedDate] = useState("");

  const handleQuoteButtonClick = (leadId) => {
    const currentDate = new Date();
    const formattedDate = `${currentDate
      .getDate()
      .toString()
      .padStart(2, "0")}/${(currentDate.getMonth() + 1)
        .toString()
        .padStart(2, "0")}/${currentDate.getFullYear()} ${currentDate
          .getHours()
          .toString()
          .padStart(2, "0")}:${currentDate
            .getMinutes()
            .toString()
            .padStart(2, "0")}`;

    setQuoteLeadId(leadId); // Set the Lead ID
    setSelectedDate(formattedDate); // Set the formatted date
    console.log("formattedDate", formattedDate);
    console.log(
      "handleQuoteButtonClick = (leadId):",
      leadId,
      "Date:",
      formattedDate
    );
    // navigate(`/qualifiedLeadsTable/quoteLead/${leadId}`);
    // navigate(`/qualifiedLeadsTable/quoteLead/${leadId}`, { state: { selectedDate } });
    navigate(`/qualifiedLeadsTable/quoteLead/${leadId}`, {
      state: { formattedDate },
    });
    if (setShowDrawer) setShowDrawer(false);
    setShowBreadcrumbs(true);
  };

  const location = useLocation();

  // Determine if the current route is for the quotation
  const isQuotationRoute = location.pathname.includes("quoteLead");

  const theme = createTheme({
    typography: {
      fontFamily: `'Figtree', sans-serif`,
    },
  });

  const [addLeadButton, setAddLeadButton] = useState(true);

  const handleGroupedClick = () => {
    setViewMode("Grouped");
    setAddLeadButton(true);
  };

  const handleNormalClick = () => {
    setViewMode("Normal");
    setAddLeadButton(true);
  };

  const handleKanbanClick = () => {
    setViewMode("Kanban");
    setAddLeadButton(false);
  };

  return (
    <div>
      {isQuotationRoute ? (
        <Outlet />
      ) : (
        <div className="px-4 pb-0 pt-0 relative text-sm font-thin  ">
          <div className="flex justify-between items-center mb-0  ">
            <div className="flex items-center justify-center gap-4 ">
              {!showBreadcrumbs && (
                <h2 className="text-xl font-normal w-[150px] ">
                  Qualified Leads
                </h2>
              )}

              {/* Breadcrumbs  */}
              {showBreadcrumbs && (
                <div role="presentation" onClick={handleBreadCrumbsClick}>
                  <div
                    role="presentation"
                    onClick={handleBreadCrumbsClick}
                    className="bg-gray-100 px-4 py-3 rounded-md shadow-md"
                  >
                    <ThemeProvider theme={theme}>
                      <Breadcrumbs
                        aria-label="breadcrumb"
                        className="flex items-center space-x-2 text-gray-600"
                      >
                        {/* Qualified Leads Breadcrumb */}
                        <Link
                          underline="hover"
                          color="inherit"
                          component={RouterLink}
                          to="/qualifiedLeadsTable"
                          className="flex items-center space-x-1 text-gray-700 hover:text-blue-600"
                        >
                          <span className="material-icons text-sm">home</span>
                          <h2 className="text-base font-medium truncate">
                            Qualified Leads
                          </h2>
                        </Link>

                        {/* Quotation Breadcrumb (conditionally rendered) */}
                        {showBreadcrumbs && quoteLeadId && (
                          <Link
                            underline="hover"
                            color="inherit"
                            component={RouterLink}
                            to={`/qualifiedLeadsTable/quoteLead/${quoteLeadId}`}
                            className="flex items-center space-x-1 text-gray-700 hover:text-blue-600"
                          >
                            <span className="material-icons text-sm">
                              receipt
                            </span>
                            <h2 className="text-base font-medium truncate">
                              Quotation
                            </h2>
                          </Link>
                        )}
                      </Breadcrumbs>
                    </ThemeProvider>
                  </div>
                </div>
              )}

              {/* Search Bar */}
              {addLeadButton && (
                <div className="flex gap-4 items-center">
                  <div className="relative flex justify-end my-2 w-[250px]  ">
                    <input
                      type="text"
                      className=" py-2 pl-10 pr-4 rounded-lg  text-black placeholder-gray-400 border border-none shadow-sm bg-white w-full"
                      placeholder="Search Qualified Leads..."
                      value={searchTerm}
                      onChange={(e) => handleSearch(e.target.value)}
                    />

                    {/* Search Icon */}
                    <div className="absolute left-3  top-1/2 transform -translate-y-1/2 ">
                      <AiOutlineSearch className="text-gray-500" />
                    </div>

                    {/* Clear Icon */}
                    {searchTerm && (
                      <div
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                        onClick={() => handleSearch("")} // Clear the search term when clicked
                      >
                        <AiOutlineClose className="text-gray-500" />
                      </div>
                    )}
                  </div>

                  {/* filter button  */}
                  <div className="">
                    <button
                      className="shadow-sm  flex items-center space-x-2 px-2 py-1 border border-none rounded-full bg-white hover:bg-gray-100"
                      style={{
                        borderRadius: "50%",
                        width: "30px",
                        height: "30px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      // onClick={() =>
                      //   document.getElementById("filterModal").classList.remove("hidden")
                      // }
                      onClick={onLeadFilter}
                    >
                      <img
                        src={filter}
                        alt="filter-icon"
                        className="w-6 h-6"
                        style={{ width: "16px", objectFit: "contain" }}
                      />
                      {/* <span className="text-sm text-gray-600">Filter</span> */}
                    </button>
                  </div>
                </div>
              )}
            </div>
            <div>
              <ButtonGroup
                variant="outlined"
                sx={{
                  backgroundColor: "white",
                  boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)", // shadow-sm equivalent
                  "& .MuiButton-outlined": {
                    border: "none", // Removes the outline
                  },
                }}
              >
                <Button
                  // onClick={() => setViewMode("Grouped")}
                  onClick={handleGroupedClick}
                  sx={{
                    backgroundColor: viewMode === "transparent", // Light blue for selected
                    "& img": {
                      filter:
                        viewMode === "Grouped"
                          ? "invert(29%) sepia(98%) saturate(2942%) hue-rotate(202deg) brightness(95%) contrast(92%)"
                          : "none", // Blue color for selected
                    },
                  }}
                >
                  <img src={grouped} alt="table-icon" className="w-6 h-6" />
                </Button>

                <Button
                  // onClick={() => setViewMode("Tabular")}
                  onClick={handleNormalClick}
                  sx={{
                    backgroundColor: viewMode === "transparent", // Light blue for selected
                    "& img": {
                      filter:
                        viewMode === "Tabular"
                          ? "invert(29%) sepia(98%) saturate(2942%) hue-rotate(202deg) brightness(95%) contrast(92%)"
                          : "none", // Blue color for selected
                    },
                  }}
                >
                  <img src={table} alt="table-icon" className="w-6 h-6" />
                </Button>

                <Button
                  // onClick={() => setViewMode("Kanban")}
                  onClick={handleKanbanClick}
                  sx={{
                    backgroundColor: viewMode === "transparent", // Light blue for selected
                    "& img": {
                      filter:
                        viewMode === "Kanban"
                          ? "invert(29%) sepia(98%) saturate(2942%) hue-rotate(202deg) brightness(95%) contrast(92%)"
                          : "none", // Blue color for selected
                    },
                  }}
                >
                  <img src={kanban} alt="kanban-icon" className="w-6 h-6" />
                </Button>
              </ButtonGroup>
            </div>
            {/* </div> */}
          </div>

          {viewMode === "Kanban" ? (
            <KanbanViewQualified rows={rows} setRows={setRows} />
          ) : viewMode === "Grouped" ? (
            <QualifiedGrouped
              // groupedQualifiedLeads={groupedQualifiedLeads}
              filteredQualifiedLeadRows={filteredQualifiedLeadRows}
              stageMapping={stageMapping}
              deleteSelectedLeads={deleteSelectedLeads}
              showDeleteModal={showDeleteModal}
              calculateAgedDays={calculateAgedDays}
              selectedLeads={selectedLeads}
              setSelectedLeads={setSelectedLeads}
              closeDeleteModal={closeDeleteModal}
              rows={rows}
              setRows={setRows}
              selectedLead={selectedLead}
              // handleSave={handleSave}
              // handleInputChange={handleInputChange}
              history={history}
            // showStageModal={showStageModal}
            // viewLead={viewLead}
            />
          ) : (
            <div>
              {selectedLeads.length > 0 && (
                <div className="mb-2">
                  <button
                    onClick={() => setShowDeleteModal(true)}
                    className="bg-red-500 text-white px-2 py-2 mt-2 rounded mr-2"
                    disabled={selectedLeads.length === 0}
                  >
                    {/* Delete Selected */}
                    {/* <img src={deleteIcon} alt="delete-icon" className="w-3 h-3 text-white" /> */}
                    <AiFillDelete size={18} />
                  </button>
                </div>
              )}

              <div className=" overflow-x-auto mt-2 max-h-[75vh] overflow-y-auto scrollbar-thin">
                <table className="table-auto w-[100%] border-collapse border border-gray-200">
                  <thead className=" bg-gray-100">
                    <tr className="">
                      <th className="shadow-sm px-1 py-0 text-left font-normal">
                        <input
                          type="checkbox"
                          className="rounded border border-sm shadow"
                          onChange={(e) =>
                            setSelectedLeads(
                              e.target.checked
                                ? qualifiedLeads.map((lead) => lead.id)
                                : []
                            )
                          }
                          checked={
                            selectedLeads.length > 0 &&
                            selectedLeads.length === qualifiedLeads.length
                          }
                        />
                      </th>
                      <th className="shadow-sm px-1 py-0 text-left w-[380px] font-normal">
                        Organization/Customer
                      </th>
                      <th className="shadow-sm px-1 py-0 text-left w-[100px] font-normal">
                        Stage
                      </th>
                      <th className="shadow-sm px-1 py-0.5 text-left w-[100px] font-normal">
                        Contact Person
                      </th>
                      <th className="shadow-sm px-1 py-0 text-left w-[150px] font-normal">
                        Title
                      </th>
                      <th className="shadow-sm px-1 py-0 text-left w-[150px] font-normal">
                        Email
                      </th>
                      <th className="shadow-sm px-1 py-0 text-left w-[100px] font-normal">
                        Phone
                      </th>
                      <th className="shadow-sm px-1 py-0 text-left w-[150px] font-normal">
                        Notes
                      </th>
                      <th className="shadow-sm px-1 py-0 text-left w-[50px] font-normal">
                        Probability
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white">
                    {console.log(
                      "filteredQualifiedLeadRows in tbody:",
                      filteredQualifiedLeadRows
                    )}
                    {filteredQualifiedLeadRows.map((row) => (
                      <tr
                        key={`${row.lead_id}-${row.stage}`}
                        className={` ${selectedLeads.includes(row.lead_id) ? "bg-blue-100" : ""
                          }`}
                      >
                        <td className="shadow-sm px-1 py-0 w-10">
                          <div className=" flex justify-right items-center gap-1.5">
                            <input
                              type="checkbox"
                              className="rounded border border-sm shadow"
                              checked={selectedLeads.includes(row.lead_id)}
                              onChange={() => handleCheckboxChange(row.lead_id, row)}
                            />

                            {row?.Cnt > 0 && (
                              <img
                                src={products}
                                alt="products-icon"
                                className="w-1 h-1 bg-green-500 text-xs p-1 rounded-lg"
                              />
                            )}
                          </div>
                        </td>

                        <td className=" shadow-sm px-1 py-0.5 w-[380px]  ">
                          <div className="flex items-end text-left justify-between  w-auto">
                            {/* <div>{row.lead_primarycontact}</div> */}
                            <div>{row.lead_organization} </div>

                            <div className="flex items-center  justify-center gap-2">
                              <img
                                onClick={() => viewLead(row.lead_id)}
                                src={expand}
                                alt="expand-icon"
                                className="w-4 h-4 cursor-pointer"
                              />
                              <div className="text-xs font-thin bg-gray-400 px-0.5 rounded-lg text-white">
                                {calculateAgedDays(row.lead_entryTime)}
                              </div>
                            </div>
                          </div>
                        </td>

                        <td
                          className="shadow-sm px-1 py-0"
                        // onClick={() => openStatusModal(row)}
                        >
                          {/* {row.status && ( */}
                          {row.lead_stage && (
                            <button
                              // onClick={() => handleStageChange("stage", row.stage)}
                              className={`w-full text-white text-center rounded p-1 mb-0.5  ${row.lead_stage === "new"
                                ? "bg-yellow-500"
                                : row.lead_stage === "discovery"
                                  ? "bg-teal-500"
                                  : row.lead_stage === "proposal"
                                    ? "bg-sky-500"
                                    : row.lead_stage === "negotiation"
                                      ? "bg-orange-600"
                                      : row.lead_stage === "won"
                                        ? "bg-green-600"
                                        : row.lead_stage === "lost"
                                          ? "bg-red-600"
                                          : "bg-gray-300"
                                }`}
                            >
                              {stageMapping[row.lead_stage] || row.lead_stage}
                            </button>
                          )}
                        </td>
                        <td className="shadow-sm px-1 py-0">
                          <div>{row.lead_primarycontact}</div>
                          {/* {row.lead_organization} */}
                        </td>
                        <td className="shadow-sm px-1 py-0">
                          {row.lead_primarycontacttitle}
                        </td>
                        <td className="shadow-sm px-1 py-0">
                          {row.lead_email}
                        </td>
                        <td className="shadow-sm px-1 py-0">
                          {row.lead_phone}
                        </td>
                        <td className="shadow-sm px-1 py-0 ">
                          {row.lead_notes}
                        </td>
                        <td className="shadow-sm px-1 py-0 text-center">
                          {row.lead_probability}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <Drawer
                showDrawer={showDrawer}
                setShowDrawer={setShowDrawer}
                selectedLead={selectedLead}
                handleInputChange={handleInputChange}
                handleSave={handleSave}
                rows={rows}
                setRows={setRows} // Passing state and updater function
                leadsWithHistory={history}
                stageMapping={stageMapping}
                setShowBreadcrumbs={setShowBreadcrumbs}
                // quoteModal={quoteModal}
                // setQuoteModal={handleQuoteModalChange}
                productDetails={productDetails}
                handleQuoteButtonClick={handleQuoteButtonClick}
                // updatedLead.leadHistory
                // leadTimeline={selectedLead.leadTimeline}
                filteredQualifiedLeadRows={filteredQualifiedLeadRows}
              />

              {/* Delete Confirmation Modal */}
              {showDeleteModal && selectedLeads.length > 0 && (
                <div className="fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-50">
                  <div className="bg-white rounded-lg shadow-lg p-6 max-w-sm w-full text-center relative">
                    {/* Image Section */}
                    <div className="flex justify-center mb-2">
                      <img
                        src={delete_Vector}
                        alt="Delete Icon"
                        className="w-1/2 h-auto max-w-xs"
                      />
                    </div>

                    {/* Close Button */}
                    <button
                      className="absolute top-6 right-8 text-gray-500 hover:text-black"
                      onClick={closeDeleteModal}
                    >
                      ✖
                    </button>

                    {/* Title Section */}
                    <div className="text-xl font-semibold text-black">
                      {selectedLeads.length === 1
                        ? "Lead Selected"
                        : "Leads Selected"}
                    </div>
                    <div className="text-gray-700 mb-6">
                      {/* Display different message based on the number of selected rows */}
                      {selectedLeads.length === 1 ? (
                        <span className="font-bold">
                          Are you sure you want to delete {checkedLead} ?
                        </span>
                      ) : (
                        <span className="font-bold">
                          Are you sure you want to delete {selectedLeads.length}{" "}
                          leads?
                        </span>
                      )}
                    </div>

                    {/* Action Buttons */}
                    <div className="flex justify-center space-x-4">
                      {/* Delete Button */}
                      <button
                        className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
                        onClick={deleteSelectedLeads} // Call delete function
                      >
                        Delete
                      </button>

                      {/* Cancel Button */}
                      <button
                        className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
                        onClick={closeDeleteModal}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {showLeadFilter && (
                <LeadFilterModal
                  rows={qualifiedLeads}
                  resetFilters={resetFilters}
                  applyFilters={applyFilters}
                  isQualifiedLeads={true}
                  closeFilter={() => setShowLeadFilter(false)}
                />
              )}

              {/* Modal Dialog for select stage */}
              {showStageModal && selectedLead && (
                <LeadStageModal
                  closeStatusModal={closeStatusModal}
                  updateStageToWon={updateStageToWon}
                  updateStageToLost={updateStageToLost}
                  selectedLead={selectedLead}
                  updateLeadStage={updateLeadStage}
                />
              )}

              {/* <DiscoveryLeads rows={rows} setRows={setRows} /> */}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default QualifiedLeads;
